const TipoFiltroEnum = Object.freeze({
    'SISTEMA': 'SISTEMA',
    'USUARIO': 'USUARIO',
    'GERAL': 'GERAL'
  })
  
  export default TipoFiltroEnum;
  